import { RolePill } from "./ui/RolePill";

interface Workspace {
  id: number;
  name: string;
  slug: string;
  workspace_type: "personal" | "team";
  role: "owner" | "admin" | "member";
  member_count: number;
  aws_accounts_count: number;
  github_repositories_count: number;
}

interface WorkspaceCardProps {
  workspace: Workspace;
}

export function WorkspaceCard({ workspace }: WorkspaceCardProps) {
  const stats = [
    workspace.workspace_type === "team"
      ? `${workspace.member_count} ${workspace.member_count === 1 ? "member" : "members"}`
      : null,
    `${workspace.aws_accounts_count} ${workspace.aws_accounts_count === 1 ? "account" : "accounts"}`,
    `${workspace.github_repositories_count} ${workspace.github_repositories_count === 1 ? "repo" : "repos"}`,
  ].filter(Boolean);

  return (
    <div className="flex items-center justify-between py-3">
      <div className="min-w-0 flex-1">
        <div className="flex items-center gap-2 mb-0.5">
          <h3
            className="text-sm font-medium text-gray-900 dark:text-gray-100 truncate"
            title={workspace.name}
          >
            {workspace.name}
          </h3>
          <RolePill role={workspace.role} />
        </div>

        <p className="text-xs text-gray-500 dark:text-gray-400">
          {stats.join(" · ")}
        </p>
      </div>

      <div className="flex-shrink-0 ml-4">
        <a
          href={`/workspaces/${workspace.slug}`}
          className="inline-flex items-center px-3 py-1.5 text-xs font-medium rounded-full border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors whitespace-nowrap cursor-pointer"
        >
          View
        </a>
      </div>
    </div>
  );
}
